import React, { ReactChild } from 'react'
import { Column } from 'rc-table'
import { TextLegacy } from '@/components/common'
import Table from '@/components/common/table/table'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'
import LinkButtonGotoPolicyPage from '@/components/domains/policy/LinkButtonGotoPolicyPage'
import { ENV_CONFIG } from '@/constants/env/config'
import { HospitalListUrl } from '@/constants/hospital-url.const'
import ROUTES from '@/constants/legacy/constRoutes'

// 개인정보의 처리목적, 수집항목, 보유 및 이용기간
const purposeOfProcessingPersonalInformationCollectionItemsRetentionAndUsePeriod = [
  {
    key: '1',
    service: '핏펫몰',
    serviceDetail: '회원가입 및 관리',
    collectionPurpose:
      '회원 가입의사 확인, 회원제 서비스 제공에 따른 본인식별∙인증, 연령인증, 회원자격 유지∙관리, 서비스 부정이용 방지, 각종 고지∙통지',
    collectionItems: (
      <>
        [필수]
        <br />- 이메일, 이름, 휴대폰 번호, SNS간편가입 업체의 사용자별 고유키(SNS간편가입시)
        <br />
        <br />
        [선택] <br />- 성별, 생년월일
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴 후 3개월까지
        <br />
        ※단, 관계법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시까지
      </>
    ),
  },
  {
    key: '2',
    service: '핏펫몰',
    serviceDetail: '반려동물 상담 및 병원연계 서비스',
    collectionPurpose: '상담 서비스 제공, 병원 연계 진행, 반려동물 정보 확인',
    collectionItems: (
      <>
        [필수]
        <br />
        - 회원 정보 : 성명, 생년월일, 성별, 휴대전화번호
        <br />
        - 반려동물 정보 : 종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부
        <br />
        <br />
        [선택]
        <br />- 상담 정보
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '3',
    service: '핏펫몰',
    serviceDetail: '병원예약 서비스',
    collectionPurpose: '병원예약 서비스 진행',
    collectionItems: (
      <>
        [필수]
        <br />
        - 회원 정보 : 이름, 휴대전화번호, 생년월일
        <br />- 반려동물 정보 : 종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '4',
    service: '핏펫몰',
    serviceDetail: '핏펫몰 서비스',
    collectionPurpose: '상품(서비스) 배송(전송), 반품, 환불, 고객상담 등 구매계약의 이행을 위해 필요한 업무의 처리',
    collectionItems: (
      <>
        [필수]
        <br />
        - 구매자 정보(이메일, 이름, 휴대폰 번호), 수취인 정보(이름, 휴대폰 번호, 배송주소), 주문정보
        <br />
        - 신용카드 결제 시 : 카드사명, 카드번호
        <br />
        - 계좌이체 시 : 예금주명. 계좌번호, 은행명
        <br />
        - 휴대폰 결제 시 : 통신사, 휴대폰번호
        <br />- 멤버십 결제 시 : 결제 빌링 키
      </>
    ),
    retentionAndUsePeriod: (
      <>
        동의철회 또는 회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '5',
    service: '핏펫몰',
    serviceDetail: '고충처리',
    collectionPurpose: '이용자의 신원 확인, 고충사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보',
    collectionItems: (
      <>
        [필수]
        <br />
        이름, 휴대폰 번호, 이메일, 배송주소, 상담 내용, 주문 정보
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '6',
    service: '핏펫몰',
    serviceDetail: '홍보 및 마케팅',
    collectionPurpose: '이벤트 및 광고성 정보 제공 및 참여기회 제공',
    collectionItems: (
      <>
        [선택]
        <br />
        고객의 서비스 이용 정보 (서비스 내 접속, 주문, 발생 이벤트 정보), 고객의 기기 정보(uuid,OS정보,app
        version,push_token), 반려 동물 정보(반려동물 종류, 반려동물 이름, 반려동물 생년월일, 반려동물 품종, 반려동물
        성별)
      </>
    ),
    retentionAndUsePeriod: (
      <>
        동의철회 또는 회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '7',
    service: '핏펫몰',
    serviceDetail: '실적정보 통계 및 신규서비스 개발',
    collectionPurpose: '상품/서비스 이용실적 정보 통계\n' + '신규 서비스 개발\n',
    collectionItems: (
      <>
        [선택]
        <br />
        고객의 서비스 이용 정보 (서비스 내 접속, 주문, 발생 이벤트 정보), 고객의 기기 정보(uuid,OS정보,app
        version,push_token),
        <br />
        반려 동물 정보(반려동물 종류, 반려동물 이름, 반려동물 생년월일, 반려동물 품종, 반려동물 성별)
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '8',
    service: 'V-Link',
    serviceDetail: '회원가입 및 관리',
    collectionPurpose:
      '회원 가입의사 확인, 회원제 서비스 제공에 따른 본인식별∙인증, 회원자격 검토 및 관리, 서비스 부정이용 방지, 각종 고지∙통지, 고충처리 목적',
    collectionItems: (
      <>
        [필수]
        <br />
        이름, 휴대폰 번호, 주소, 이메일, 소속대학
        <br />
        <br />
        [수의사 회원의 경우 추가수집]
        <br />
        수의사 면허번호, 수의사 면허증 이미지, 소속 병원명, 소속병원 주소
        <br />
        <br />
        [수의과대학생 회원의 경우 추가수집]
        <br />
        학생증 이미지, 소속학번
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '9',
    service: 'V-Link',
    serviceDetail: '결제 프로세스',
    collectionPurpose: '강의 결제업무 처리',
    collectionItems: (
      <>
        [필수]
        <br />
        성명, 생년월일, 주소, 전화번호, 이메일 주소, 결제수단 정보(신용카드 번호, 유효기간, 카드소유자명, 은행 계좌
        정보, 계좌주명)
      </>
    ),
    retentionAndUsePeriod: (
      <>
        동의철회 또는 회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '10',
    service: 'V-Link',
    serviceDetail: '홍보 및 마케팅',
    collectionPurpose: '자체 설문조사를 위한 개인정보 제공',
    collectionItems: (
      <>
        [선택]
        <br />
        이름, 휴대폰 번호, 주소, 이메일, 소속대학
        <br />
        <br />
        [수의사 회원의 경우 추가수집]
        <br />
        수의사 면허번호, 소속 병원명, 소속병원 주소, 개원연차
        <br />
        <br />
        [수의과대학생 회원의 경우 추가수집]
        <br />
        소속학번
      </>
    ),
    retentionAndUsePeriod: (
      <>
        동의철회 또는 회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    key: '11',
    service: 'V-Link',
    serviceDetail: '실적정보 통계 및 신규서비스 개발',
    collectionPurpose: '상품/서비스 이용실적 정보 통계 신규 서비스 개발',
    collectionItems: (
      <>
        [선택]
        <br />
        고객의 서비스 이용 정보 (서비스 내 접속, 발생 이벤트 정보), 고객의 기기 정보(uuid,OS정보,app version,push_token)
      </>
    ),
    retentionAndUsePeriod: (
      <>
        회원 탈퇴시까지
        <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
]

// 법정 의무 보유기간
type StatutoryRetentionPeriodDataType = {
  statute?: string
  item: string
  period: string
}

const statutoryRetentionPeriod: StatutoryRetentionPeriodDataType[] = [
  {
    statute: '전자상거래 등에서의 소비자 보호에 관한 법률 제6조 및 시행령 제6조제1항',
    item: '계약 또는 청약철회, 대금결제, 재화 등의 공급기록',
    period: '5년',
  },
  {
    item: '소비자의 불만 또는 분쟁처리에 관한 기록',
    period: '3년',
  },
  {
    item: '표시/광고에 관한 기록',
    period: '6개월',
  },
  {
    statute: '국세기본법',
    item: '세법이 규정하는 모든 거래에 관한 장부 및 증빙서류',
    period: '5년',
  },
  {
    statute: '전자금융거래법 제22조제1항 및 시행령 제12조제1항',
    item: '전자금융 거래에 관한 기록',
    period: '5년',
  },
  {
    statute: '통신비밀보호법 제15조의2 및 시행령 제41조제2항제2호',
    item: '서비스 방문기록',
    period: '3개월',
  },
  {
    statute: '신용정보의 이용 및 보호에 관한 법률 제20조제2항',
    item: '신용정보의 수집∙처리 및 이용 등에 관한 기록',
    period: '3년',
  },
]

const statutoryRetentionPeriodColumns = [
  {
    title: '근거법령',
    dataIndex: 'statute',
    render: (value: string, _record: any, index: number) => {
      const rowSpan = index === 0 ? 3 : index && index < 3 ? 0 : 1
      return { children: value, props: { rowSpan } }
    },
  },
  {
    title: '보유 항목',
    dataIndex: 'item',
  },
  {
    title: '보유 기간',
    dataIndex: 'period',
    render: (value: string, _record: any) => {
      return { children: value, props: { style: { fontWeight: 'bold' } } }
    },
  },
]

// 개인정보의 제 3자 제공
type ProvisionOfPersonalInformationToThirdPartiesDataType = {
  company: ReactChild
  purpose: ReactChild
  item: ReactChild
  period: ReactChild
}

const provisionOfPersonalInformationToThirdParties: ProvisionOfPersonalInformationToThirdPartiesDataType[] = [
  {
    company: '핏펫 제휴 수의사',
    purpose: '상담 서비스 제공, 병원 연계 진행, 반려동물 정보 확인',
    item: (
      <>
        [회원 정보]
        <br />
        성명, 생년월일, 성별, 휴대전화번호, 상담 정보
        <br />
        [반려동물 정보]
        <br />
        종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부
      </>
    ),
    period: (
      <>
        동의철회 또는 회원 탈퇴시까지 <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    company: (
      <>
        핏펫 제휴 동물병원 및 병원 제휴 중개업체
        <br />
        [<LinkButtonGotoPolicyPage text="링크 참조" url={HospitalListUrl} />]
      </>
    ),
    purpose: '병원예약 서비스 진행',
    item: (
      <>
        [회원 정보]
        <br />
        이름, 휴대전화번호, 생년월일
        <br />
        [반려동물 정보]
        <br />
        종류, 성별, 이름, 나이, 몸무게, 품종, 중성화 여부
      </>
    ),
    period: (
      <>
        동의철회 또는 회원 탈퇴시까지 <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    company: (
      <>
        핏펫 판매자(셀러)
        <br />
        [<LinkButtonGotoPolicyPage text="링크 참조" url={`${ENV_CONFIG.fitpetmallHost}${ROUTES.POLICY.SELLERS}`} />]
      </>
    ),
    purpose: '상품(서비스) 배송(전송), 반품, 환불, 고객상담 등 구매계약의 이행을 위해 필요한 업무의 처리\n',
    item: '이름, 휴대전화번호, 배송주소, 주문정보 (구매자와 수취인이 다를 경우는 수취인의 정보가 함께 제공됩니다)\n',
    period: (
      <>
        동의철회 또는 회원 탈퇴시까지 <br />
        ※단, 법정 의무 보유기간에 따라 보관
      </>
    ),
  },
  {
    company: (
      <>
        <span style={{ textDecoration: 'underline' }}>DB손해보험 주식회사</span>
      </>
    ),
    purpose: (
      <>
        <span style={{ textDecoration: 'underline' }}>
          DB손해보험 펫보험 가입자 본인 확인, 원활한 거래 진행, 서비스 분석과 통계에 따른 혜택 및 맞춤 서비스 제공,
          민원처리 등 고객상담, 고객관리, 분쟁조정을 위한 기록 보존
        </span>
      </>
    ),
    item: (
      <>
        <span style={{ textDecoration: 'underline' }}>(휴대)전화번호</span>
      </>
    ),
    period: (
      <>
        <span style={{ textDecoration: 'underline' }}>위 개인정보 이용목적 달성 시 까지</span>
      </>
    ),
  },
]

const provisionOfPersonalInformationToThirdPartiesColumns = [
  {
    title: '제공받는 자',
    dataIndex: 'company',
  },
  {
    title: '제공목적',
    dataIndex: 'purpose',
  },
  {
    title: '제공항목',
    dataIndex: 'item',
  },
  {
    title: '보유 및 이용기간',
    dataIndex: 'period',
  },
]

// 개인정보처리의 위탁
const columnsConsignment = [
  {
    title: '위탁 업체',
    dataIndex: 'company',
    key: 'company',
  },
  {
    title: '위탁 업무',
    dataIndex: 'job',
    key: 'job',
  },
  {
    title: '보유 및 처리기간',
    dataIndex: 'period',
    key: 'period',
    render: (value: string, _record: any, index: number) => {
      const rowSpan = index === 0 ? 7 : 0
      return { children: value, props: { rowSpan } }
    },
  },
]

const dataSourceConsignment = [
  {
    key: 1,
    company: '롯데글로벌로지스',
    job: '고객 대상 제품 배송 및 회송',
    period: '회원 탈퇴 시 혹은 위탁 계약 종료 시 지체 없이 파기',
  },
  {
    key: 2,
    company: 'NHN한국사이버결제, 토스페이먼츠㈜',
    job: '고객의 이용대금 결제 및 정산 처리',
  },
  {
    key: 3,
    company: '(주)루나소프트, 알리고',
    job: 'SMS/LMS/MMS, 카카오톡 알림톡(정보성 메시지) 등 메시지 발송 업무',
  },
  {
    key: 4,
    company: 'Braze Inc.',
    job: '사용자의 상품, 서비스 이용 및 통계 분석, 마케팅 활용을 위한 모바일(앱푸시, 이메일 등) 발송 관련 서비스',
  },
  {
    key: 5,
    company: ' Zendesk, 고객센터(메타엠)',
    job: '고객센터 운영, 고객 문의 및 안내 관리 등 고객 상담',
  },
  {
    key: 6,
    company: '㈜아임포트',
    job: '주문 연동 전자결제 업무',
  },
  {
    key: 7,
    company: 'Amplitude Inc, Appsflyer, Google ads',
    job: '사용자의 상품, 서비스 이용 및 통계 분석',
  },
  {
    key: 8,
    company: '㈜한국사이버결제',
    job: 'V-Link 결제서비스 제공',
  },
  {
    key: 9,
    company: '㈜알리는사람들',
    job: 'V-Link 문자메시지, 이메일 등 발송 대행',
  },
  {
    key: 10,
    company: '에스아이비',
    job: '고객 대상 제품 배송 및 회송',
  },
]

// 개인정보보호책임자
type PersonInChargeOfPersonalInformationProtectionDataType = {
  type: ReactChild
  name: ReactChild
  contact: ReactChild
}

const personInChargeOfPersonalInformationProtectionData: PersonInChargeOfPersonalInformationProtectionDataType[] = [
  {
    type: (
      <>
        개인정보보호책임자
        <br />
        개인정보보호 담당부서
        <br />
        개인정보 열람청구
      </>
    ),
    name: (
      <>
        직책 : CTO
        <br />
        성명 : 장재훈
      </>
    ),
    contact: (
      <>
        전화번호 : 02-6339-1800
        <br />
        이메일 : contact@fitpet.co.kr
      </>
    ),
  },
]

const PersonalLocationInformationDataType = [
  {
    title: '서비스명',
    dataIndex: 'name',
    key: 'name',
    width: '12%',
    render: (value: React.ReactNode, _record: any, index: number) => {
      const rowSpan = index === 0 ? 2 : index && index < 2 ? 0 : 1
      return { children: value, props: { rowSpan } }
    },
  },
  {
    title: '서비스 내용 및 위치정보 처리목적',
    dataIndex: 'purpose',
    key: 'purpose',
    render: (value: React.ReactNode) => {
      return { children: value }
    },
  },
  {
    title: '처리항목',
    dataIndex: 'job',
    key: 'job',
    render: (value: React.ReactNode, _record: any, index: number) => {
      const rowSpan = index === 0 ? 3 : 0
      return { children: value, props: { rowSpan } }
    },
  },
]

const personalLocationInformationData = [
  {
    key: 1,
    name: '병원',
    purpose: (
      <>
        ① 위치정보를 활용한 병원 찾기 서비스: 정보 검색을 요청하거나 개인위치정보주체 또는 이동성 있는 기기의 위치정보를
        제공 시 본 위치정보를 이용한 검색결과 및 주변결과(주변 동물병원 등)을 제시합니다.
      </>
    ),
    job: <>개인위치정보주체 또는 이동성 있는 기기의 위치정보</>,
  },
  {
    key: 2,
    name: '병원',
    purpose: (
      <>
        ② 병원 안내 등 생활편의 서비스 제공: 이용자가 설정한 위치에서부터 선택한 동물병원까지의 교통정보와 길 안내 등
        최적의 경로를 제공합니다.
      </>
    ),
  },
  {
    key: 3,
    name: '건강',
    purpose: (
      <>
        위치정보를 활용한 산책하기 서비스: 개인위치정보주체 또는 이동성 있는 기기의 위치 정보를 제공 시 본 위치정보를
        이용하여 실제 이동한 거리의 측정 및 걸음수를 제공합니다.
      </>
    ),
  },
]

interface Props {
  fontSize?: FontResponsiveSizeType
  subTitleFontSize?: FontResponsiveSizeType
}

const PolicyPrivacy = ({ fontSize = { xs: 12, md: 14 }, subTitleFontSize = { xs: 14, md: 16 } }: Props) => {
  return (
    <div style={{ padding: 10, paddingTop: 40 }}>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        주식회사 핏펫은 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」, 「위치정보 보호법」 및 관계 법령이 정한
        바를 준수하여, 적법하게 개인(위치)정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조,
        「위치정보 보호법」 21조에 따라 정보주체에게 개인(위치)정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한
        고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인(위치)정보 처리방침을 수립∙공개합니다.
      </TextLegacy>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보의 처리목적, 수집항목, 보유 및 이용기간
      </TextLegacy>
      <div style={{ height: 4 }} />

      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        주식회사 핏펫은 다음과 같이 정보주체의 개인정보를 처리합니다.
      </TextLegacy>
      <Table
        data={purposeOfProcessingPersonalInformationCollectionItemsRetentionAndUsePeriod}
        style={{ marginTop: 20, paddingBottom: 10, verticalAlign: 'top' }}
      >
        <Column title={'서비스'} width="10%" dataIndex="service" />
        <Column title={'세부서비스'} width="14%" dataIndex="serviceDetail" />
        <Column title={'수집 목적'} width="26%" dataIndex="collectionPurpose" />
        <Column title={'수집 항목'} width="32%" dataIndex="collectionItems" />
        <Column title={'보유 및 이용기간'} width="18%" dataIndex="retentionAndUsePeriod" />
      </Table>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        ※ 법정 의무 보유기간에 따라 일정 기간 보관 후 파기하는 정보는 아래와 같습니다.
      </TextLegacy>
      <Table
        columns={statutoryRetentionPeriodColumns}
        data={statutoryRetentionPeriod}
        style={{ marginTop: 20, paddingBottom: 10, verticalAlign: 'top' }}
      />

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보의 제3자 제공
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 주식회사 핏펫은 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의
          동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게
          제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.
          <br />② 주식회사 핏펫은 원활한 서비스 제공을 위해 다음의 경우 정보주체의 동의를 얻어 필요 최소한의 범위로만
          제공합니다
        </TextLegacy>
        <Table
          columns={provisionOfPersonalInformationToThirdPartiesColumns}
          data={provisionOfPersonalInformationToThirdParties}
          style={{ marginTop: 20, paddingBottom: 10, verticalAlign: 'top' }}
        />
        <TextLegacy size={fontSize}>
          ③ 정부 관계부처가 합동으로 발표한 「긴급상황 시 개인정보 처리 및 보호수칙」에 따라 재난, 감염병, 급박한
          생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보주체의 동의 없이
          관계기관에 개인정보를 제공할 수 있습니다. 자세한 사항은
          <LinkButtonGotoPolicyPage
            text="여기*"
            url="https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS217&nttId=7641&mCode=D010030000&bbsTyCode=BBST01&bbsAttrbCode=BBSA03&authFlag=Y&pageIndex=1&catCd=&etc1=&etc2=&etc3=&searchCnd=6&searchWrd="
          />
          를 눌러 확인하시기 바랍니다.
          <br />이 경우 주식회사 핏펫은 근거법령에 의거하여 필요한 최소한의 개인정보만을 제공하며, 목적과 다르게
          제공하지 않겠습니다.
        </TextLegacy>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보처리의 위탁
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 주식회사 핏펫은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
        </TextLegacy>
        <Table
          data={dataSourceConsignment}
          columns={columnsConsignment}
          style={{ marginTop: 20, paddingBottom: 10, verticalAlign: 'top' }}
        />
        <TextLegacy size={fontSize}>
          ② 주식회사 핏펫은 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
          기술적∙관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리∙감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에
          명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
          <br />③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록
          하겠습니다.
        </TextLegacy>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보의 파기
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 주식회사 핏펫은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당
          개인정보를 파기합니다.
          <br />
          ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라
          개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를
          달리하여 보존합니다.
          <br />③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
        </TextLegacy>
        <div style={{ marginLeft: 14 }}>
          <TextLegacy size={fontSize}>
            1. 파기절차
            <br />
            주식회사 핏펫은 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를
            파기합니다.
            <br />
            2. 파기방법
            <br />
            주식회사 핏펫은 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 기술적 방법을 이용하여
            파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
          </TextLegacy>
        </div>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        정보주체와 법정대리인의 권리∙의무 및 행사방법
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 정보주체는 주식회사 핏펫에 대해 언제든지 개인정보 열람∙정정∙삭제∙처리정지 요구 등의 권리를 행사할 수
          있습니다.
          <br />
          ② 권리행사는 주식회사 핏펫에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 이메일 등을 통하여 하실
          수 있으며, 주식회사 핏펫은 이에 대해 지체없이 조치하겠습니다.
          <br />
          ③ 권리행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보
          처리방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
          <br />
          ④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가
          제한될 수 있습니다.
          <br />
          ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를
          요구할 수 없습니다.
          <br />⑥ 주식회사 핏펫은 정보주체 권리에 따른 열람의 요구, 정정∙삭제의 요구, 처리정지의 요구 시 열람 등 요구를
          한 자가 본인이거나 정당한 대리인인지를 확인합니다.
        </TextLegacy>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보의 안전성 확보조치
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div>
        <TextLegacy size={fontSize}>
          주식회사 핏펫은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
        </TextLegacy>
        <div style={{ marginLeft: 14 }}>
          <TextLegacy size={fontSize}>
            1. 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육 <br />
            2. 기술적 조치 : 해킹 등에 대비한 기술적 대책개인정보의 암호화, 접속기록의 보관 및 위변조 방지 등 <br />
            3. 물리적 조치 : 서버실, 자료보관실 등의 접근통제
          </TextLegacy>
        </div>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          1. 주식회사 핏펫은 정보주체에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는
          &apos;쿠키(cookie)&apos;를 사용합니다.
          <br />
          2. 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며
          이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
        </TextLegacy>
        <div style={{ marginLeft: 14 }}>
          <TextLegacy size={fontSize}>
            1) 쿠키의 사용목적: 이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 서비스 사용 패턴 파악 및 자취 추적,
            보안 접속 여부, 이용자 규모 등을 통해 보안 관리 및 서비스 개선 및 신규 서비스 개발, 맞춤형 서비스 및 광고
            제공에 이용합니다.
            <br />
            2) 쿠키의 설치·운영 및 거부 : 서비스 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹
            브라우저에서 옵션의 설정을 변경함으로써 쿠키의 저장을 거부할 수 있습니다.
            <br />
            3) 3. 쿠키 저장을 거부할 경우 일부 서비스 이용에 어려움이 발생할 수 있습니다.
            <br />
            4) 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
          </TextLegacy>
        </div>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        행태정보의 수집∙이용 및 거부에 관한 사항
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 주식회사 핏펫은 서비스 이용과정에서 정보주체에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을
          제공하기 위하여 행태정보를 수집·이용하지 않습니다.
          <br />② 주식회사 핏펫은 다음과 같이 온라인 맞춤형 광고 사업자가 행태정보를 수집·처리하도록 허용하고 있습니다.
          <div style={{ marginLeft: 14 }}>
            - 행태정보를 수집 및 처리하려는 광고 사업자 : Braze Inc, Amplitude Inc, Appsflyer, Google ads
            <br />
            - 행태정보 수집 방법 : 이용자가 당사 웹사이트를 방문하거나 앱을 실행할 때 자동 수집 및 전송
            <br />
            - 수집·처리되는 행태정보 항목 : 고객의 서비스 이용 정보 (서비스 내 접속, 주문, 발생 이벤트 정보), 고객의
            기기 정보(uuid,OS정보,app version,push_token)
            <br />- 보유·이용기간 : 회원 탈퇴 시 또는 위탁 계약 종료 시까지
          </div>
          ③ 주식회사 핏펫은 사상, 신념, 가족 및 친인척관계, 학력·병력, 기타 사회활동 경력 등 개인의 권리·이익이나
          사생활을 뚜렷하게 침해할 우려가 있는 민감한 행태정보를 수집하지 않습니다.
          <br />
          ④ 주식회사 핏펫은 만 14세 미만임을 알고 있는 아동이나 만14세 미만의 아동을 주 이용자로 하는 온라인
          서비스로부터 맞춤형 광고 목적의 행태정보를 수집하지 않고, 만 14세 미만임을 알고 있는 아동에게는 맞춤형 광고를
          제공하지 않습니다.
          <br />⑤ 주식회사 핏펫은 모바일 앱에서 온라인 맞춤형 광고를 위하여 제2항과 같이 광고식별자를 수집·이용하도록
          허용합니다. 정보주체는 모바일 단말기의 설정 변경을 통해 앱의 맞춤형 광고를 차단·허용할 수 있습니다.
          <div style={{ marginLeft: 14 }}>
            ‣ 스마트폰의 광고식별자 차단/허용
            <br />
            (1) (안드로이드) ① 설정 → ② 개인정보보호 → ③ 광고 → ③ 광고 ID 재설정 또는 광고ID 삭제
            <br />
            (2) (아이폰) ① 설정 → ② 개인정보보호 → ③ 추적 → ④ 앱이 추적을 요청하도록 허용 끔
            <br />※ 모바일 OS 버전에 따라 메뉴 및 방법이 다소 상이할 수 있습니다.
          </div>
          ⑥ 정보주체는 웹브라우저의 쿠키 설정 변경 등을 통해 온라인 맞춤형 광고를 일괄적으로 차단·허용할 수 있습니다.
          다만, 쿠키 설정 변경은 웹사이트 자동로그인 등 일부 서비스의 이용에 영향을 미칠 수 있습니다.
          <div style={{ marginLeft: 14 }}>
            ‣ 웹브라우저를 통한 맞춤형 광고 차단/허용
            <br />
            (1) 인터넷 익스플로러(Windows 10용 Internet Explorer 11)
            <br />
            - Internet Explorer에서 도구 버튼을 선택한 다음 인터넷 옵션을 선택
            <br />
            - 개인 정보 탭을 선택하고 설정에서 고급을 선택한 다음 쿠키의 차단 또는 허용을 선택
            <br />
            (2) Microsoft Edge
            <br />
            - Edge에서 오른쪽 상단 ‘…’ 표시를 클릭한 후, 설정을 클릭합니다.
            <br />
            - 설정 페이지 좌측의 ‘개인정보, 검색 및 서비스’를 클릭 후 「추적방지」 섹션에서 ‘추적방지’ 여부 및 수준을
            선택합니다.
            <br />
            - ‘InPrivate를 검색할 때 항상 “엄격” 추적 방지 사용’ 여부를 선택합니다.
            <br />
            - 아래 「개인정보」 섹션에서 ‘추적 안함 요청보내기’ 여부를 선택합니다.
            <br />
            (3) 크롬 브라우저
            <br />
            - Chrome에서 오른쪽 상단 ‘⋮’ 표시(chrome 맞춤설정 및 제어)를 클릭한 후, 설정 표시를 클릭합니다.
            <br />
            - 설정 페이지 하단에 ‘고급 설정 표시’를 클릭하고 「개인정보」 섹션에서 콘텐츠 설정을 클릭합니다.
            <br />- 쿠키 섹션에서 ‘타사 쿠키 및 사이트 데이터 차단’의 체크박스를 선택합니다.
          </div>
          ⑦ 정보주체는 아래의 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수
          있습니다.
          <div style={{ marginLeft: 14 }}>
            ‣ 개인정보 보호 담당부서
            <br />
            부서명 : IT 프로덕트 본부
            <br />
            담당자 : 장재훈
            <br />
            연락처 : &lt;02-6339-1800&gt;,&nbsp; &lt;contact@fitpet.co.kr&gt;
          </div>
        </TextLegacy>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보보호책임자 및 개인정보 열람청구
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 주식회사 핏펫은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및
          피해구제 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.
          <br />
          ② 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 주식회사
          핏펫은 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
          <br />③ 정보주체는 주식회사 핏펫의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보보호 관련 문의,
          불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 주식회사 핏펫은
          정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.
        </TextLegacy>
        <Table data={personInChargeOfPersonalInformationProtectionData} style={{ paddingBottom: 10 }}>
          <Column title="구분" dataIndex="type" />
          <Column title="성명 등" dataIndex="name" />
          <Column title="연락처" dataIndex="contact" />
        </Table>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        권리침해 구제 방법
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 주식회사 핏펫은 정보주체의 개인정보자기결정권을 보장하고, 개인정보침해로 인한 상담 및 피해 구제를 위해
          노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다.
          <div style={{ marginLeft: 14 }}>
            ‣ 고충처리 부서
            <br />
            부서명 : CTO
            <br />
            담당자 : 장재훈
            <br />
            연락처 : &lt;02-6339-1800&gt;, &lt; contact@fitpet.co.kr &gt;
          </div>
          ② 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원
          개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에
          대하여는 아래의 기관에 문의하시기 바랍니다.
          <div style={{ marginLeft: 14 }}>
            1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)
            <br />
            2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)
            <br />
            3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)
            <br />
            4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)
          </div>
          ③ 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의
          규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는
          행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
          <div style={{ marginLeft: 14 }}>‣ 중앙행정심판위원회 : (국번없이) 110 (www.simpan.go.kr)</div>
        </TextLegacy>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인위치정보의 처리 관련
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          1. 위치정보 처리목적, 처리항목, 보유기간
          <br />① 주식회사 핏펫은 서비스 제공을 위하여 고객의 위치정보를 처리하며, 서비스 명칭과 내용, 위치정보의
          처리목적 및 처리항목은 아래 표와 같습니다.
        </TextLegacy>
        <Table
          data={personalLocationInformationData}
          columns={PersonalLocationInformationDataType}
          style={{ paddingBottom: 10 }}
        />
        <TextLegacy size={fontSize}>
          ② 개인위치정보의 제3자 제공에 관한 사항 : 해당사항 없음
          <br />
          2. 개인위치정보 수집ㆍ이용ㆍ제공사실 확인자료의 보유근거 및 보유기간
          <br />
          주식회사 핏펫은 위치정보법 제16조 제2항에 근거하여 이용자의 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를
          위치정보시스템에 자동으로 기록하며, 6개월 동안 보관합니다.
          <br />
          3. 개인위치정보 파기 절차 및 방법
          <br />
          ① 주식회사 핏펫은 개인위치정보의 처리목적이 달성된 경우, 위치정보관리 책임자의 승인을 받아 개인위치정보를
          재생이 불가능한 방법으로 안전하게 파기합니다.
          <br />
          ② 전자적 파일 형태로 기록ㆍ저장된 개인위치정보는 기록을 재생할 수 없도록 기술적 방법을 이용하여 파기하며, 종이
          문서에 기록ㆍ저장된 개인위치정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
          <br />
          4. 개인위치정보 제3자 제공에 관한 사항
          <br />
          ① 주식회사 핏펫은 정보주체의 사전 동의가 있거나 ‘개인정보보호법’, ‘긴급상황 시 개인정보 처리 및 보호수칙’ 등
          법령에 의거한 경우가 아닌 한 정보주체의 개인위치정보를 제3자에게 제공하지 않습니다.
          <br />
          ② 주식회사 핏펫이 정보주체가 지정하는 제3자에게 정보주체의 개인위치정보를 제공하기 위해서는 사전에 정보주체의
          개인위치정보를 제공받는 자 및 제공목적을 정보주체에게 고지하고 동의를 받습니다.
          <br />
          ③ 주식회사 핏펫이 사전에 정보주체가 지정한 제3자에게 정보주체의 개인위치정보를 제공한 경우, 제공 직후 혹은
          정보주체가 선택한 기간 및 횟수에 따라 정보제공 내역을 정보주체에게 통지합니다.
          <br />
          5. 8세 이하 아동 등의 보호의무자의 권리의무
          <br />
          ① 주식회사 핏펫은 아래의 경우에 해당하는 이용자(이하 “8세 이하의 아동 등”이라 함)의 보호의무자가 8세 이하의
          아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는
          것으로 봅니다.
          <br />
          1) 8세 이하의 아동
          <br />
          2) 피성년후견인
          <br />
          3) 장애인복지법 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법
          제2조제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 사람에
          한정)
          <br />
          ② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는
          보호의무자는 서면으로 아래 각 호의 사항을 기재하고 기명날인(서명)한 뒤 보호의무자임을 증명하는 서면을 첨부하여
          주식회사 핏펫에 제출하여야 합니다.
          <br />
          1) 8세 이하 아동 등의 성명, 주소, 생년월일
          <br />
          2) 보호의무자의 성명, 주소, 연락처
          <br />
          3) 개인위치정보 수집, 이용 또는 제공의 목적이 8세 이하 아동등의 생명 또는 신체의 보호에 한정된다는 사실
          <br />
          4) 동의 연월일
          <br />
          ③ 보호의무자가 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를
          행사할 수 있습니다.
          <br />
          6. 위치정보 관리책임자
          <br />- 성명: 장재훈
          <br />
          - 부서명: IT 프로덕트 본부
          <br />
          - 전화번호, 이메일: &lt;02-6339-1800&gt;, &lt;contact@fitpet.co.kr&gt;
          <br />
        </TextLegacy>
      </div>

      <div style={{ height: 20 }} />
      <TextLegacy size={subTitleFontSize} style={{ display: 'inline', fontWeight: 'bold' }}>
        개인정보 처리방침의 변경
      </TextLegacy>
      <div style={{ height: 4 }} />

      <div style={{ marginLeft: 14 }}>
        <TextLegacy size={fontSize}>
          ① 이 개인정보 처리방침은 <span style={{ textDecoration: 'underline' }}>2023. 11. 15.</span>부터 적용됩니다.
          <br />② 이전의 개인정보 처리방침은 링크에서 확인하실 수 있습니다.
        </TextLegacy>
      </div>
      <div style={{ height: 20 }} />

      <LinkButtonGotoPolicyPage
        text="이전 처리방침 보기"
        url={`${ENV_CONFIG.fitpetmallHost}${ROUTES.POLICY.BEFORE_PRIVACY_20231031}`}
      />
    </div>
  )
}

export default PolicyPrivacy
